import { ChevronDown } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export type NewInvoiceKind = 'invoice' | 'recurring' | 'credit-note';

interface Props {
  onSelect: (kind: NewInvoiceKind) => void;
}

export function NewInvoiceMenu({ onSelect }: Props) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" className="flex h-10 items-center gap-2 rounded-full bg-primary-s500 px-5 text-sm font-medium text-white hover:bg-blue-700">
          New Invoice <ChevronDown size={16} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuItem className="bg-primary-s500 text-white focus:bg-primary-s500 focus:text-white" onClick={() => onSelect('invoice')}>
          New Invoice
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onSelect('recurring')}>New Recurring Invoice</DropdownMenuItem>
        <DropdownMenuItem onClick={() => onSelect('credit-note')}>New Credit Note</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
